import React from 'react';
import {ShowableProductCard} from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import {observer} from "mobx-react";
import { SpecialBadgeNs } from 'ReactApp/Types/SpecialBadgeNs';
import { BadgeTypeEnum } from 'ReactApp/Types/enum';

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type ShowableProductCardBadgeListV1Props = {
    productCard: ShowableProductCard
}

/**
 * TODO[needImpl]: TMP-component, given data from server and use standart BadgeListV1 after MVP-checking
 */
const ShowableProductCardBadgeListV1 = observer((props: ShowableProductCardBadgeListV1Props) => {

    let badgeSaleWrapClasses: string[] = [
        'badge-v1',
        'badge-v1__discount-label',
        'badge-v1_text-color-type-white',
        'badge-v1_filling-color-type-main',
        'badge-v1_filling-type-contained',
        'badge-v1_icon-color-type-white',
        'badge-v1_content-type-label',
    ];
    // if (props.productCard.discountPercentage === null) {
    //     badgeSaleWrapClasses.push('_hide');
    // }

    function renderBadge(badge: SpecialBadgeNs.SpecialBadge, index: number) {
        switch (badge.badgeTypeId) {
            case BadgeTypeEnum.discount:
                return (
                    <div key={`ble-${index}`} className={badgeSaleWrapClasses.join(' ')}>
                        <div className="badge-v1__wrap">
                            <div className="badge-v1__label">
                                {badge.label}
                            </div>
                        </div>
                    </div>
                );
            break;
            case BadgeTypeEnum.fastDelivery:
                return (
                    <div
                        key={`ble-${index}`}
                        className="
                            badge-v1
                            badge-v1_text-color-type-main
                            badge-v1_filling-color-type-main
                            badge-v1_filling-type-outlined
                            badge-v1_icon-color-type-white
                            badge-v1_content-type-label-and-icon
                        ">
                        <div className="badge-v1__wrap">
                            <div className="badge-v1__icon">
                                <svg className="icon-v1" width="18" height="12">
                                    <use xlinkHref="/build/sprite.svg#car-icon"></use>
                                </svg>
                            </div>
                            <div className="badge-v1__label">
                                Быстрая<br/>доставка
                            </div>
                        </div>
                    </div>
                );
            break;
            case BadgeTypeEnum.gift:
                return (
                    <div
                        key={`ble-${index}`}
                        className="
                            badge-v1
                            badge-v1_text-color-type-white
                            badge-v1_filling-color-type-text
                            badge-v1_filling-type-contained
                            badge-v1_icon-color-type-white
                            badge-v1_content-type-icon
                            js-tooltip
                        "
                        data-pt-title={badge.tooltipContent}
                        >
                        <div className="badge-v1__wrap">
                            <div className="badge-v1__icon">
                                <svg className="icon-v1" width="14" height="14">
                                    <use xlinkHref="/build/sprite.svg#gift-icon"></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                );
            break;
        }
    }

    return (
        <>
            {
                props.productCard.badges.map((badge, index) => (
                    renderBadge(badge, index)
                ))
            }
        </>
    );

})

export default ShowableProductCardBadgeListV1;